<template>
  <button
    :class="buttonClasses"
    @click="clicked = true"
  >
    Bereken
  </button>
</template>

<script>
export default {
  name: 'Button',
  data () {
    return {
      clicked: false
    }
  },
  computed: {
    buttonClasses () {
      return {
        'button': true,
        'is-clicked': this.clicked
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  background-color: $c-red;
  display: inline-block;
  color: white;
  border: none;
  width: 219px;
  padding: 11px 0 15px;
  line-height: 1;
  border-radius: 25px;
  font-weight: $fw-medium;
  border-bottom: 4px solid #A31411;
  position: absolute;
  top: 26px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 2;
  cursor: pointer;
  transition: all 500ms ease;
  outline: 0;
  animation: pulse 2s infinite;
}

.is-clicked {
  border-bottom-width: 0;
  background-color: #A31411;
  transform: translateY(4px);
  opacity: 0.5;
  animation: none;
}
</style>
